import { combineReducers } from "redux";
import studentReducer from "../features/student/studentSlice";
import uiReducer from "../features/ui/uiSlice";
import assignmentReducer from "../features/assignment/assignmentSlice";
import paperAssignmentReducer from "../features/paper-assignment/paperAssignmentSlice";

const rootReducer = combineReducers({
  student: studentReducer,
  ui: uiReducer,
  assignment: assignmentReducer,
  paperAssignment: paperAssignmentReducer,
});

export default rootReducer;
